import template from './backup_managers_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class BackupManagersHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class BackupManagersHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new BackupManagersHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'BackupManagersHelp',
	dialog_class: BackupManagersHelpPage,
	template: template,
	template_filename: 'translation/dialogs/backup_managers_help',
	provider: 'ps'
};
